import TextIconColumn, { cellType, textIconColumnConfiguration } from './TextIconColumn.component';

export { cellType, TextIconColumn };
export default textIconColumnConfiguration;
